export const getHelpCenterLink=()=> {
  const link = window.location.hostname === 'app.resumescripter.com' || window.location.hostname === 'appdemo.resumescripter.com' ? 'https://rshelprequest.paperform.co/' : 'https://rshelp.paperform.co';

  return link;
}